import { Grid, Stack } from "@mui/material";
import { AWS_URL } from "../../../configs/constants";

interface ProductIconProps {
  productIconArray: string[];
  isAsset?: boolean;
  size?: "small" | "normal";
}

const ProductIcon = ({ productIconArray, isAsset = false, size = "normal" }: ProductIconProps) => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        width: "100%",
        height: "100%",
        placeContent: "center"
      }}
    >
      {productIconArray.map((item, index) => (
        <Grid item xs={4} sm={4} md={4} key={index} sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
          <img
            src={isAsset ? item : `${AWS_URL}/${item}`}
            alt="product"
            style={ 
              size === "normal" ? { width: "7rem", height: "7rem", objectFit: "contain" } : { width: "5rem", height: "5rem", objectFit: "contain" }}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ProductIcon;
